import $ from 'jquery'
import { document } from 'ssr-window'

export default function (handler) {
  let intervalHandler = null

  return {
    mousedown: () => {
      let delay = setTimeout(() => {
        if (!delay) {
          return
        }

        intervalHandler = setInterval(() => {
          handler()
        }, 100)
      }, 400)

      clearInterval(intervalHandler)
      handler()
      $(document).one('mouseup', () => {
        clearTimeout(delay)
        delay = null

        clearInterval(intervalHandler)
        intervalHandler = null
      })
    },
  }
}
